import Vue from 'vue';
import Vuex from 'vuex';
import { DEFAULT_PROJECT } from '@/constants';
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    customSelectionId: DEFAULT_PROJECT.id,
    customSelectionName: DEFAULT_PROJECT.name,
    customSelectionCheckedProducts: DEFAULT_PROJECT.checkedProducts,
    radios: [],
    isSpinnerLoading: false,
    loadingRequests: 0,
    loadingTimeout: null
  },
  getters: {
    activeCategories: state => {
      return Object.keys(state.customSelectionCheckedProducts).filter(
        key => state.customSelectionCheckedProducts[key].length
      );
    },
    checkedProducts: state => sectionName => {
      return state.customSelectionCheckedProducts[sectionName];
    },
    radios: state => state.radios,
    isSpinnerLoading: state => state.isSpinnerLoading,
    loadingCount: state => state.loadingRequests
  },
  mutations: {
    customSelectionId: (state, payload) => {
      state.customSelectionId = payload;
    },
    customSelectionName: (state, payload) => {
      state.customSelectionName = payload;
    },
    customSelectionCheckedProducts: (state, payload) => {
      state.customSelectionCheckedProducts = { ...payload };
    },
    radios: (state, payload) => {
      state.radios = payload;
    },
    isSpinnerLoading: (state, payload) => {
      state.isSpinnerLoading = payload;
    },
    incrementLoading(state) {
      state.loadingRequests++;

      if (!state.loadingTimeout) {
        state.loadingTimeout = setTimeout(() => {
          if (state.loadingRequests > 0) {
            state.isSpinnerLoading = true
          }
        }, 300)
      }
    },
    decrementLoading(state) {
      state.loadingRequests = Math.max(0, state.loadingRequests - 1)
      
      if (state.loadingRequests === 0) {
        if (state.loadingTimeout) {
          clearTimeout(state.loadingTimeout)
          state.loadingTimeout = null
        }
        
        state.isSpinnerLoading = false
      }
    },
    resetLoading(state) {
      state.loadingRequests = 0
      state.isSpinnerLoading = false
    }
  },
  actions: {}
});
